import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, Search, Bell, LogOut, ShieldCheck, ChevronDown, CheckCircle2 } from 'lucide-react';
import ThemeSwitch from '../Theme/ThemeSwitch';
import { logout } from '../../services/authService';
import './Topbar.scss';

const Topbar = ({ onToggleSidebar = () => {}, onOpenSearch = () => {} }) => {
  const navigate = useNavigate();
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const user = useMemo(() => {
    const stored = localStorage.getItem('user');
    if (!stored) return null;
    try {
      return JSON.parse(stored);
    } catch {
      return null;
    }
  }, []);

  const role = (user?.userType || user?.role || 'admin').toLowerCase();
  const roleLabel =
    role === 'muhtar'
      ? 'Mahalle Muhtarı'
      : role === 'library'
        ? 'Kütüphane Personeli'
        : role === 'printer'
          ? 'Toner Sorumlusu'
          : role === 'sports' || role === 'sporsuperadmin'
            ? 'Spor Sorumlusu'
            : role === 'regionalsports'
              ? 'Bölge Sorumlusu'
              : role === 'istirakler'
                ? 'İştirak Yetkilisi'
                : role === 'basin'
                  ? 'Basın Yayın Merkezi'
                  : role === 'department'
                    ? 'Birim Personeli'
                    : 'Yönetici';
  const displayName = user?.nameSurname || user?.name || 'Kullanıcı';

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <header className="arc-topbar">
      <div className="arc-topbar-left">
        <button
          type="button"
          className="arc-topbar-btn arc-menu-toggle"
          onClick={onToggleSidebar}
          aria-label="Menüyü Aç/Kapat"
          title="Menüyü Aç/Kapat"
        >
          <Menu size={18} />
        </button>
      </div>

      <div className="arc-topbar-center">
        <button
          type="button"
          className="arc-command-launcher"
          onClick={onOpenSearch}
          title="Komut ve sayfa arama"
        >
          <Search size={15} className="arc-launcher-icon" />
          <span className="arc-launcher-placeholder">Sayfa veya işlem ara...</span>
        </button>
      </div>

      <div className="arc-topbar-right">
        {/* Arc Theme Switcher */}
        <ThemeSwitch />

        {/* User Profile */}
        <div className="arc-profile-wrapper">
          <button
            type="button"
            className="arc-profile-btn"
            onClick={() => setShowProfileMenu((prev) => !prev)}
            aria-expanded={showProfileMenu}
          >
            <div className="arc-avatar">
              <span>{displayName.charAt(0).toUpperCase()}</span>
              <span className="arc-avatar-online"></span>
            </div>
            <div className="arc-profile-meta">
              <span className="arc-profile-name">{displayName}</span>
              <span className="arc-profile-role">{roleLabel}</span>
            </div>
            <ChevronDown size={14} className="arc-profile-chevron" />
          </button>

          {showProfileMenu && (
            <div className="arc-profile-dropdown" onClick={() => setShowProfileMenu(false)}>
              <div className="arc-dropdown-header">
                <span className="arc-dropdown-name">{displayName}</span>
                <span className="arc-dropdown-badge">{roleLabel}</span>
              </div>
              <div className="arc-dropdown-divider" />
              <button
                type="button"
                className="arc-dropdown-item"
                onClick={() => navigate('/settings')}
              >
                <ShieldCheck size={15} />
                <span>Hesap & Ayarlar</span>
              </button>
              <button
                type="button"
                className="arc-dropdown-item danger"
                onClick={handleLogout}
              >
                <LogOut size={15} />
                <span>Çıkış Yap</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Topbar;
